import styles from "../Cadastro/Styles/CadastroJornada.module.scss";
// import input from "../../components/Input/InputDeloitte.module.scss";
import { Input } from "../../components/Input/Input";
// import Select from "../../components/Select/Select";
import Checkbox from "../../components/Checkbox/Checkbox";
import Swal from "sweetalert2";
import { swalTheme, Toast } from "../../services/Swal";
import { validaCpf } from "../../components/validacoes";
// import { Helmet } from "react-helmet";
// import aaaa from "./Styles/favicon.sga.ico";

import {
  AlignRight,
  InputArea,
  InputAreaDupla,
} from "../../components/Box/Box";

import { ContainedBtn, OutlineBtn } from "../../components/ButtonTypes/Button";

import logo from "../../assets/logo-horiz-movimento.gif";
import h1 from "../../assets/B1.png";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faContactCard,
  faUser,
  faEye,
  faEyeSlash,
  faCircleMinus,
  faCirclePlus,
  faPhoneAlt,
  faUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import Select from "../../components/Select/Select";
import Widget, { setWidgetIsOpen } from "../../components/Widget/Widget";

function CadastroJornada() {
  const [toggleCep, setToggleCep] = useState(false);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [ceds, setCeds] = useState([{}]);
  const [toggleNumero, setToggleNumero] = useState(false);
  const [toggleSenha, setToggleSenha] = useState(false);
  const [termos, setTermos] = useState([{}]);
  const [form, setForm] = useState({});

  function checkSenha(
    password,
    ifWrong = () => {
      Toast.fire({
        icon: "error",
        // title: "Senha fraca",
        title:
          "A senha deverá conter oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial.",
      });
      setForm({
        ...form,
        senha: "",
        //confirmaSenha: "",
      });
    }
  ) {
    if (!password) return;
    //const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm;
    const pattern = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g;

    if (pattern.test(password)) return password;
    return ifWrong;
  }

  function validaSenha(senha, confirmaSenha) {
    if (senha !== confirmaSenha) {
      Toast.fire({
        icon: "error",
        title: "Confirmação de senha inválida",
      });
      setForm({
        ...form,
        //senha: "",
        confirmaSenha: "",
      });
    }
  }

  const handleToggleSenha = (e) => {
    e.preventDefault();
    setToggleSenha(!toggleSenha);
  };

  async function getTermos() {
    await fetch(
      `${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/GetTermos/Cadastro?projeto=Deloitte`
    )
      .then((response) => response.json())
      .then((data) => {
        setTermos(data.payload);
        // console.log(data.payload);
      });
  }

  function handleDataNascimentoUsuario(data) {
    var dob = new Date(data);
    if (data === null || data === "") {
      return false;
    } else {
      var month_diff = Date.now() - dob.getTime();

      var age_dt = new Date(month_diff);

      var year = age_dt.getUTCFullYear();

      if (year < 1970) {
        setForm({ ...form, dataNascimento: "" });
        Toast.fire({
          icon: "error",
          title: "Ano de nascimento inválido",
        });
        return;
      }

      var age = Math.abs(year - 1970);

      if (age < 13) {
        setForm({ ...form, dataNascimento: "" });
        Toast.fire({
          icon: "error",
          title: "Ano de nascimento inválido",
        });
        return;
      }

      return age;
    }
  }

  function handleDataNascimentoResponsavel(data) {
    var dob = new Date(data);
    if (data === null || data === "") {
      return false;
    } else {
      var month_diff = Date.now() - dob.getTime();

      var age_dt = new Date(month_diff);

      var year = age_dt.getUTCFullYear();

      if (year < 1970) {
        return false;
      }

      var age = Math.abs(year - 1970);

      if (age < 18) {
        setForm({ ...form, dataNascimentoResponsavel: "" });
        Toast.fire({
          icon: "error",
          title: "Responsavel não pode ser menor de 18 anos",
        });
        return;
      }

      if (age > 100) {
        setForm({ ...form, dataNascimentoResponsavel: "" });
        Toast.fire({
          icon: "error",
          title: "Ano de nascimento do responsável inválido",
        });
        return;
      }

      return age;
    }
  }

  function handleCPF(cpf) {
    if (!cpf) return;
    if (!validaCpf(cpf)) {
      setForm({ ...form, cpf: "" });
      Toast.fire({
        icon: "error",
        title: "CPF inválido",
      });
    }
  }

  async function selectCidade(uf) {
    if (!uf) return;
    await fetch(`${process.env.REACT_APP_API_ESTADO}/${uf}/municipios`)
      .then((response) => response.json())
      .then((data) => setCidades(data));
  }

  // async function selectCed() {
  //   await fetch(
  //     `${process.env.REACT_APP_BACKEND}/api/Deloitte/CadastroDeloitte`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => setCeds(data));
  // }

  async function selectEstado() {
    await fetch(process.env.REACT_APP_API_ESTADO)
      .then((response) => response.json())
      .then((data) => setEstados(data));
  }

  useEffect(() => {
    selectEstado();
    getTermos();
    //selectCed();
  }, []);

  useEffect(() => {
    fetch("https://sganew.recode.org.br/api/publics/ceds")
      .then(res => res.json())
      .then(i => setCeds(i))
      .catch(e => console.error(e))
  }, [])

  useEffect(() => {
    selectCidade(form?.endereco?.estado);
  }, [form?.endereco?.estado]);

  function checkCep(e) {
    const cep = e.target.value;
    if (!cep) return;
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((cep) => {
        if (cep.erro) {
          setToggleCep(true);
          Toast.fire({
            icon: "info",
            title: "CEP não localizado",
          });
        } else {
          setForm({
            ...form,
            endereco: {
              ...form.endereco,
              endereco: cep.logradouro,
              bairro: cep.bairro,
              estado: cep.uf,
              cidade: cep.localidade,
              complemento: cep.complemento,
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
        setForm({
          ...form,
          endereco: {
            ...form.endereco,
            cep: "",
          },
        });
        Toast.fire({
          icon: "error",
          title: "CEP inválido",
        });
      });
  }

  async function submitForm(obj) {
    const termosEnviar = [];

    const keys = Object.keys(form?.termos);

    keys.map((termo) => {
      return termosEnviar.push({
        nome: termo,
        aceite: form?.termos[termo],
      });
    });

    const body = {
      email: obj.email,
      nome: obj.nome,
      senha: obj.senha,
      dataNascimento: obj.dataNascimento,
      cpf: obj.cpf,
      realizacaoCurso:
        obj?.realizacaoCurso === "Outro"
          ? obj?.realizacaoCursoOutro || null
          : obj.realizacaoCurso,

      // idCed: obj.idCed,
      instituicao: obj.instituicao, //undefined 
      endereco: {
        pais: "Brasil",
        cep: obj.endereco.cep,
        estado: obj.endereco.estado,
        cidade: obj.endereco.cidade,
        bairro: obj.endereco.bairro,
        endereco: obj.endereco.endereco,
        numero: obj.endereco.numero,
        complemento: obj.endereco.complemento,
      },
      cpfResponsavel: obj.cpfResponsavel,
      lgbtqia: obj.lgbtqia,
      refugiado: obj.refugiado,

      escolaridade: obj.escolaridade,
      trabalhando: obj.trabalhando,
      renda: obj.renda,

      grauParentesco: obj.grauParentesco,
      dataNascimentoResponsavel: obj.dataNascimentoResponsavel,
      nomeResponsavel: obj.nomeResponsavel,
      telefoneResponsavel: obj.telefoneResponsavel,
      termos: termosEnviar,
      confirmaSenha: obj.confirmaSenha,

      telefone: obj.telefone,
      whatsapp: obj.whatsapp,
      genero: obj.genero,
      raca: obj.raca,
      pcd: obj.pcd,
    };

    //return console.log(body)

    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_BACKEND}/api/Deloitte/CadastroDeloitte`,
      request
    )
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);

        if (result.success)
          return Swal.fire({
            title: "Sucesso!",
            text: "O seu cadastro foi efetuado com sucesso! Por favor realizar o login.",
            icon: "success",
            ...swalTheme,
          }).then(() => {
            window.location.replace("https://jornada.recode.org.br/");
          });

        return Swal.fire({
          title: "Erro",
          text: result.message,
          icon: "error",
          ...swalTheme,
        });
      })
      .catch((error) => {
        console.log("error", error);
        Swal.fire({
          title: "Erro",
          text: "Um erro ocorreu!",
          icon: "error",
          ...swalTheme,
        });
      });
    console.log(body);
  }

  function validaTermos() {
    const termosObrigatorios = termos.filter((termo) => termo.obrigatorio);
    let validou = true;

    termosObrigatorios.map((termo) => {
      return !form.termos?.[termo.nome] ? (validou = false) : null;
    });

    if (validou) {
      submitForm(form);
    } else {
      Toast.fire({
        icon: "error",
        title:
          "O aceite dos termos de concentimento e política de dados Recode serão necessários.",
      });
    }
  }

  const apenasLetras = "[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$";
  const outlinedStyle = { fontSize: ".7em", padding: ".3em .5em" };

  const [isWidgetLoading, setIsWidgetLoading] = useState(false)
  const [widgetForm, setWidgetForm] = useState({
    nome: "",
    email: "",
    assunto: "",
    projeto: "Jornada",
    corpo: ""
  });

  async function submitWidget() {
    setIsWidgetLoading(true)
    console.log(widgetForm)
    await fetch(`${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/DispararEmail`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nomeRementente: widgetForm.nome,
        emailRemetente: widgetForm.email,
        projeto: widgetForm.projeto,
        assunto: widgetForm.assunto,
        corpo: widgetForm.corpo
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          Toast.fire({ icon: "success", title: "Sua mensagem foi enviada com sucesso!" });
          setWidgetForm({ nome: "", email: "", assunto: "", projeto: "QOT", corpo: "" })
        } else {
          Toast.fire({ icon: "warning", title: "Espere alguns instantes para enviar uma nova mensagem." });
        }
      })
      .catch((error) => {
        console.log("error", error);
        Toast.fire({ icon: "Erro", title: "Um erro ocorreu!" });
      })
      .finally(() => {
        setIsWidgetLoading(false)
        setWidgetIsOpen(false)
      });
  }

  return (
    <>
      <Widget
        content={
          <form
            style={{ display: "flex", gap: "5px", flexDirection: "column" }}
            onSubmit={(e) => {
              e.preventDefault();
              submitWidget();
            }}
          >
            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Nome"
                value={widgetForm.nome}
                onChange={(e) => setWidgetForm({ ...widgetForm, nome: e.target.value })}
              />
            </InputArea>

            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Email"
                type="email"
                placeholder="estudante@email.com"
                value={widgetForm.email}
                onChange={(e) => setWidgetForm({ ...widgetForm, email: e.target.value })}
              />
            </InputArea>

            <InputArea>
              <Select
                disabled={isWidgetLoading}
                className={styles.select}
                required
                label="Assunto"
                onChange={(e) => setWidgetForm({ ...widgetForm, assunto: e.target.value })}
              >
                <option>Elogio</option>
                <option>Dúvida</option>
                <option>Cadastro</option>
                <option>Problema técnico</option>
                <option>Outro</option>
              </Select>
            </InputArea>

            <InputArea>
              <textarea
                disabled={isWidgetLoading}
                className={styles.textarea}
                required
                rows={5}
                placeholder="Sua mensagem"
                value={widgetForm.corpo}
                onChange={(e) => setWidgetForm({ ...widgetForm, corpo: e.target.value })}
              ></textarea>
            </InputArea>

            <InputArea>
              <ContainedBtn className={styles.submitBtn} disabled={isWidgetLoading} > {!isWidgetLoading ? "Enviar" : "Enviando..."} </ContainedBtn>
            </InputArea>
          </form>
        }
      />
      <section>
        <img src={logo} alt="logo" className={styles.logo} />
      </section>

      <hr className={styles.separador} />

      <section className={styles.cadastroH1}>
        <img src={h1} alt="Cadastro de Estudante" className={styles.img} />
      </section>

      <br />
      <form
        className={styles.formArea}
        onSubmit={(e) => {
          e.preventDefault();
          validaTermos();
          //validaSenha(form.senha, form.confirmaSenha);
        }}
      >
        <InputAreaDupla>
          <section className={styles.titleAndIcon}>
            <FontAwesomeIcon icon={faContactCard} className={styles.faicon} />
            <h2 className={styles.fontH2}>Dados de acesso</h2>
          </section>
        </InputAreaDupla>

        <InputArea>
          <Input
            required
            className={styles.input}
            label="E-mail"
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
        </InputArea>

        <InputArea>
          <Input
            className={styles.input}
            // label="Usuário"
            label="&nbsp;"
            value={form.email}
            disabled
          />
        </InputArea>

        <InputArea>
          <Input
            required
            className={styles.input}
            type={toggleSenha ? "text" : "password"}
            label="Senha"
            subText="A senha deverá conter oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial."
            value={form.senha}
            onBlur={checkSenha(form.senha)}
            onChange={(e) => setForm({ ...form, senha: e.target.value })}
          />
        </InputArea>
        <InputArea>
          <Input
            required
            type={toggleSenha ? "text" : "password"}
            className={styles.input}
            label="Confirme sua senha"
            value={form.confirmaSenha}
            onBlur={() => validaSenha(form.senha, form.confirmaSenha)}
            onChange={(e) =>
              setForm({ ...form, confirmaSenha: e.target.value })
            }
          />
          <AlignRight>
            <OutlineBtn
              onClick={handleToggleSenha}
              className={styles.outlineBtn}
              style={outlinedStyle}
            >
              {toggleSenha ? (
                <FontAwesomeIcon icon={faEyeSlash} />
              ) : (
                <FontAwesomeIcon icon={faEye} />
              )}
            </OutlineBtn>
          </AlignRight>
        </InputArea>

        <InputAreaDupla>
          <section className={styles.titleAndIcon}>
            <h3 className={styles.fontH2}>
              <FontAwesomeIcon icon={faUser} className={styles.faicon} />
              Dados Pessoais
            </h3>
          </section>
        </InputAreaDupla>

        <InputAreaDupla>
          <Input
            required
            className={styles.input}
            // pattern="[a-zA-Z]*"
            pattern={apenasLetras}
            title="O seu nome não pode conter números."
            label="Nome Completo (Nome Social Completo)"
            value={form.nome}
            onChange={(e) => setForm({ ...form, nome: e.target.value })}
          />
        </InputAreaDupla>
        <InputArea>
          <Input
            required
            className={styles.input}
            label="Data de nascimento"
            type="date"
            value={form.dataNascimento}
            onChange={(e) =>
              setForm({ ...form, dataNascimento: e.target.value })
            }
            onBlur={() => {
              handleDataNascimentoUsuario(form.dataNascimento);
            }}
          />
        </InputArea>
        {/* {console.log(  handleDataNascimento(form.dataNascimento))} */}
        {handleDataNascimentoUsuario(form.dataNascimento) < 18 && (
          <>
            <InputArea>
              <Input
                required
                className={styles.input}
                label="Nome do Responsável"
                value={form.nomeResponsavel}
                onChange={(e) =>
                  setForm({ ...form, nomeResponsavel: e.target.value })
                }
              />
            </InputArea>
            <InputArea>
              <Input
                required
                className={styles.input}
                label="CPF do responsável"
                mask="999.999.999-99"
                placeholder="000.000.000-00"
                value={form.cpfResponsavel}
                onChange={(e) =>
                  setForm({ ...form, cpfResponsavel: e.target.value })
                }
                onBlur={(e) => {
                  handleCPF(e.target.value);
                }}
              />
            </InputArea>
            <InputArea>
              <Input
                required
                className={styles.input}
                label="Telefone: DDD+N° do Responsavel"
                type="tel"
                mask="(99) 99999-9999"
                placeholder="(00) 12345-6789"
                value={form.telefoneResponsavel}
                onChange={(e) =>
                  setForm({ ...form, telefoneResponsavel: e.target.value })
                }
              />
            </InputArea>
            <InputArea>
              <Input
                required
                className={styles.input}
                label="Grau de Parentesco"
                value={form.grauParentesco}
                onChange={(e) =>
                  setForm({ ...form, grauParentesco: e.target.value })
                }
              />
            </InputArea>
            <InputArea>
              <Input
                required
                className={styles.input}
                label="Data de nascimento do Responsável"
                type="date"
                value={form.dataNascimentoResponsavel}
                onChange={(e) =>
                  setForm({
                    ...form,
                    dataNascimentoResponsavel: e.target.value,
                  })
                }
                onBlur={() => {
                  handleDataNascimentoResponsavel(
                    form.dataNascimentoResponsavel
                  );
                }}
              />
            </InputArea>
          </>
        )}
        <InputArea>
          <Input
            required
            className={styles.input}
            label="CPF"
            mask="999.999.999-99"
            placeholder="000.000.000-00"
            value={form.cpf}
            onChange={(e) => setForm({ ...form, cpf: e.target.value })}
            onBlur={(e) => {
              handleCPF(e.target.value);
            }}
          />
        </InputArea>
        <InputAreaDupla>
          <Select
            required
            className={styles.select}
            // label="Como fará os cursos?"
            label="Como chegou a este curso?"
            value={form.realizacaoCurso}
            onChange={(e) =>
              setForm({ ...form, realizacaoCurso: e.target.value })
            }
          >
            {/*<option disabled>Selecione</option>
             <option>Farei em uma instituição</option>
            <option>Farei incentivado(a)/indicado(a) por uma instituição</option>
            <option>Farei sozinho(a), sem vínculo com uma instituição</option> */}
            <option>Linkedin</option>
            <option>Instagram / Twitter / Facebook</option>
            <option>Indicação de colega ou familiar</option>
            <option>Site Recode</option>
            <option>Via site de busca</option>
            <option>Email marketing</option>
            <option>WhatsApp</option>
            <option>Comercial de TV</option>
            <option>Youtube</option>
            <option>Via Instituição parceira</option>
            <option>Quebrando o Tabu</option>
            <option>Outros</option>
          </Select>
        </InputAreaDupla>

        {
          // form?.realizacaoCurso === "Farei em uma instituição" ||
          // form?.realizacaoCurso === "Farei incentivado(a)/indicado(a) por uma instituição"
          form?.realizacaoCurso === "Via Instituição parceira" && (
            // <InputAreaDupla>
            //   <Select
            //     required
            //     className={styles.select}
            //     value={form.idCed}
            //     label="Qual instituição"
            //     onChange={(e) => setForm({ ...form, idCed: e.target.value })}
            //   >
            //     {ceds
            //       //.sort((a, b) => a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0)
            //       .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
            //       .map((ced) => (
            //         <option key={ced.id} value={ced.id}>
            //           {ced.nome}
            //         </option>
            //       ))}
            //   </Select>
            // </InputAreaDupla>

            <InputAreaDupla>
              <Select
                required
                className={styles.select}
                value={form.instituicao}
                label="Qual instituição"
                onChange={(e) => setForm({ ...form, instituicao: e.target.value })}
              >
                {ceds
                  //.sort((a, b) => a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0)
                  .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
                  .map((ced) => (
                    <option key={ced.id} value={ced.nome.toUpperCase()}>
                      {ced.nome.toUpperCase()}
                    </option>
                  ))}
              </Select>
            </InputAreaDupla>
          )
        }

        {/* {form?.realizacaoCurso === "Outro" && ( */}
        {/* {form?.realizacaoCurso === "Outros" && (
          <InputAreaDupla>
            <Input
              required
              className={styles.input}
              value={form.realizacaoCursoOutro}
              label="Como irá fazer os cursos?"
              onChange={(e) =>
                setForm({ ...form, realizacaoCursoOutro: e.target.value })
              }
            />
          </InputAreaDupla>
        )} */}

        <InputArea>
          <Select
            className={styles.select}
            required
            label="Como você se percebe/identifica em relação ao seu gênero?"
            onChange={(e) => setForm({ ...form, genero: e.target.value })}
          >
            <option>Feminino TRANS</option>
            <option>Feminino CIS</option>
            <option>Masculino TRANS</option>
            <option>Masculino CIS</option>
            <option>Não binário</option>
            <option>Prefiro não informar</option>
            <option>Outros</option>
          </Select>
        </InputArea>

        <InputArea>
          <Select
            className={styles.select}
            required
            label="Como você se percebe/identifica em relação à sua raça?"
            onChange={(e) => setForm({ ...form, raca: e.target.value })}
          >
            <option>Amarela</option>
            <option>Branca</option>
            <option>Indígena</option>
            <option>Parda</option>
            <option>Preta</option>
            <option>Prefiro não informar</option>
          </Select>
        </InputArea>

        <InputArea>
          <Select
            required
            className={styles.select}
            label="Você se identifica como LGBTQIAPN+?"
            subText="A sigla LGBTQIAPN+ representa pessoas que são Lésbicas, Gays, Bissexuais, Transexuais, Queer, Intersexo, Assexuais, Pansexuais e Não-binárias."
            onChange={(e) => setForm({ ...form, lgbtqia: e.target.value })}
          >
            <option>Sim</option>
            <option>Não</option>
            <option>Prefiro não informar</option>
          </Select>
        </InputArea>

        <InputArea>
          <Select
            className={styles.select}
            required
            label="Você se considera refugiado(a)?"
            onChange={(e) => setForm({ ...form, refugiado: e.target.value })}
            subText="Refugiado/a é a pessoa que está “fora de seu país de origem devido a fundados temores de perseguição relacionados a questões de raça, religião, nacionalidade, pertencimento a um determinado grupo social ou opinião política, como também devido à grave e generalizada violação de direitos humanos e conflitos armados”, segundo a ACNUR, Agência da ONU para Refugiados."
          >
            <option>Sim</option>
            <option>Não</option>
            <option>Prefiro não responder</option>
          </Select>
        </InputArea>

        <InputAreaDupla>
          <Select
            className={styles.select}
            required
            label="Qual é o seu nível de escolaridade mais alto?"
            onChange={(e) => setForm({ ...form, escolaridade: e.target.value })}
          >
            <option>Ensino Fundamental incompleto</option>
            <option>Ensino Fundamental completo</option>
            <option>Ensino Médio/Técnico incompleto</option>
            <option>Ensino Médio/Técnico completo</option>
            <option>Graduação incompleta</option>
            <option>Graduação completa ou mais</option>
          </Select>
        </InputAreaDupla>

        <InputAreaDupla>
          <Select
            className={styles.select}
            required
            label="Você está trabalhando?"
            onChange={(e) => setForm({ ...form, trabalhando: e.target.value })}
          >
            <option>Sim, com carteira assinada (incluindo Jovem Aprendiz)</option>
            <option>Sim, sem carteira assinada, mas com contrato (microempreendedor individual, Pessoa Jurídica, etc)</option>
            <option>Sim, informal ou bicos</option>
            <option>Sim, sou servidor/a público</option>
            <option>Não estou trabalhando</option>
            <option>Prefiro não informar</option>
          </Select>
        </InputAreaDupla>

        {[
          "Sim, com carteira assinada (incluindo Jovem Aprendiz)",
          "Sim, sem carteira assinada, mas com contrato (microempreendedor individual, Pessoa Jurídica, etc)",
          "Sim, informal ou bicos",
          "Sim, sou servidor/a público"
        ].includes(form.trabalhando) && (
            <InputAreaDupla>
              <Select
                className={styles.select}
                required
                label="De quanto foi sua renda no último mês?"
                onChange={(e) => setForm({ ...form, renda: e.target.value })}
              >
                <option>Até R$660,00</option>
                <option>Entre R$661,01 e R$1.320,00</option>
                <option>Entre R$1.320,01 e R$2.640,00</option>
                <option>Entre R$2.640,01 e R$3.960,00</option>
                <option>R$3.960,01 ou mais</option>
                <option>Prefiro não informar</option>
              </Select>
            </InputAreaDupla>
          )}

        <InputAreaDupla>
          <Select
            className={styles.select}
            required
            label="Você é uma pessoa com deficiência?"
            onChange={(e) => setForm({ ...form, pcd: e.target.value })}
          >
            <option>Sim</option>
            <option>Não</option>
          </Select>
        </InputAreaDupla>

        <InputAreaDupla>
          <section className={styles.titleAndIcon}>
            <h3 className={styles.fontH2}>
              <FontAwesomeIcon className={styles.faicon} icon={faPhoneAlt} />
              Dados de Contato
            </h3>
          </section>
        </InputAreaDupla>

        <InputArea>
          <Input
            className={styles.input}
            label="Telefone"
            type="tel"
            mask="(99) 99999-9999"
            placeholder="(00) 12345-6789"
            value={form.telefone}
            onChange={(e) => setForm({ ...form, telefone: e.target.value })}
          />
        </InputArea>

        <InputArea>
          <span className={styles.label}>Whatsapp</span>
          <div>
            <Checkbox
              label="Este telefone é meu whatsapp"
              name="whatsapp"
              //value="sim"
              checked={form.whatsapp}
              className={styles.checkbox}
              onChange={(e) => setForm({ ...form, whatsapp: e.target.checked })}
            >
              Este telefone é meu whatsapp
            </Checkbox>
          </div>
        </InputArea>

        <InputArea>
          <Input
            className={styles.input}
            label="Selecione seu País"
            value="Brasil"
            readonly
          />
        </InputArea>
        <InputArea>
          <Input
            required
            className={styles.input}
            label="CEP"
            mask="99999-999"
            placeholder="00000-000"
            value={form.endereco?.cep}
            onBlur={checkCep}
            onChange={(e) =>
              setForm({
                ...form,
                endereco: { ...form.endereco, cep: e.target.value },
              })
            }
            disabled={toggleCep}
          />
          <AlignRight>
            <ContainedBtn
              className={styles.outlineBtn}
              style={outlinedStyle}
              onClick={(e) => {
                e.preventDefault();
                setToggleCep((current) => !current);
                setForm({
                  ...form,
                  endereco: {
                    ...form.endereco,
                    bairro: "",
                    estado: "",
                    cidade: "",
                    endereco: "",
                    complemento: "",
                    cep: "",
                  },
                });
              }}
            >
              {!toggleCep ? (
                <p>
                  Não tenho CEP <FontAwesomeIcon icon={faCircleMinus} />
                </p>
              ) : (
                <p>
                  Tenho CEP <FontAwesomeIcon icon={faCirclePlus} />
                </p>
              )}
            </ContainedBtn>
          </AlignRight>
        </InputArea>
        <InputArea>
          <Select
            required
            className={styles.select}
            disabled={!toggleCep}
            label="Estado"
            value={form.endereco?.estado}
            onChange={(e) => {
              setForm({
                ...form,
                endereco: { ...form.endereco, estado: e.target.value },
              });
            }}
          >
            {estados
              .sort((a, b) => (a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0))
              .map((estado) => (
                <option key={estado.id} value={estado.sigla}>
                  {estado.sigla}
                </option>
              ))}
          </Select>
        </InputArea>
        <InputArea>
          <Select
            required
            className={styles.select}
            disabled={!form?.endereco?.estado || !toggleCep}
            label="Cidade"
            value={form.endereco?.cidade}
            onChange={(e) =>
              setForm({
                ...form,
                endereco: { ...form.endereco, cidade: e.target.value },
              })
            }
          >
            {cidades
              .sort((a, b) => (a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0))
              .map((cidade) => (
                <option key={cidade.id} value={cidade.sigla}>
                  {cidade.nome}
                </option>
              ))}
          </Select>
        </InputArea>

        <InputArea>
          <Input
            required
            className={styles.input}
            disabled={!toggleCep}
            label="Bairro"
            value={form.endereco?.bairro}
            onChange={(e) =>
              setForm({
                ...form,
                endereco: { ...form.endereco, bairro: e.target.value },
              })
            }
          />
        </InputArea>
        <InputArea>
          <Input
            required
            className={styles.input}
            disabled={!toggleCep}
            label="Endereço"
            value={form.endereco?.endereco}
            onChange={(e) =>
              setForm({
                ...form,
                endereco: { ...form.endereco, endereco: e.target.value },
              })
            }
          />
        </InputArea>
        <InputArea className={styles.aaaa}>
          <Input
            required
            className={styles.input}
            label="Número"
            value={form.endereco?.numero}
            onChange={(e) =>
              setForm({
                ...form,
                endereco: { ...form.endereco, numero: e.target.value },
              })
            }
            disabled={toggleNumero}
          />
          <AlignRight>
            <ContainedBtn
              className={styles.outlineBtn}
              style={outlinedStyle}
              onClick={(e) => {
                e.preventDefault();
                setToggleNumero((current) => !current);
                setForm({
                  ...form,
                  endereco: { ...form.endereco, numero: "" },
                });
              }}
            >
              {!toggleNumero ? (
                <p>
                  &nbsp; Sem Número <FontAwesomeIcon icon={faCircleMinus} />
                </p>
              ) : (
                <p>
                  &nbsp; Tenho Número <FontAwesomeIcon icon={faCirclePlus} />
                </p>
              )}
            </ContainedBtn>
          </AlignRight>
        </InputArea>
        <InputArea>
          <Input
            className={styles.input}
            label="Complemento"
            value={form.endereco?.complemento}
            onChange={(e) =>
              setForm({
                ...form,
                endereco: { ...form.endereco, complemento: e.target.value },
              })
            }
          />
        </InputArea>

        {termos
          .sort((a, b) =>
            a.obrigatorio > b.obrigatorio
              ? 1
              : b.obrigatorio > a.obrigatorio
                ? -1
                : 0
          )
          .map((termo, index) => (
            <InputAreaDupla key={index}>
              <Checkbox
                key={termo.nome}
                className={styles.checkbox}
                // value={form[termo.nome]}
                checked={form?.termos?.[termo?.nome]}
                onChange={(e) => {
                  setForm({
                    ...form,
                    termos: { ...form.termos, [termo.nome]: e.target.checked },
                  });
                }}
                required
              >
                <span>
                  {termo.descricao}
                  {termo.obrigatorio && "* "}
                  {termo.link && (
                    <a
                      className={styles.checkboxA}
                      rel="noopener noreferrer"
                      href={termo.link}
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={faUpRightFromSquare} />
                    </a>
                  )}
                </span>
              </Checkbox>
            </InputAreaDupla>
          ))}

        {/* <button
          onClick={(e) => {
            e.preventDefault();
            validaSenha(form.senha, form.confirmaSenha);

          }}
        >
          Log
        </button> */}

        <InputAreaDupla>
          <AlignRight>
            <ContainedBtn className={styles.submitBtn}>Enviar</ContainedBtn>
          </AlignRight>
        </InputAreaDupla>
      </form>
    </>
  );
}
export default CadastroJornada;
